export default __webpack_public_path__ + "static/MediaContentEleven-42747bb779fb8fe0a8534c2748a53cab.webp";